// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			//scrollDownAction(60, 'scroll'); //function change logo on scroll
		})
	};

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//let scrollButtons = document.querySelectorAll('.sub-menu ul li a');

	// if(scrollButtons.length > 0){
	// 	scrollButtons.forEach((button)=>{
	// 		button.addEventListener('click', (e)=>{
	// 			e.preventDefault();
	// 			let data = button.getAttribute('href').split('#')[1];
	// 			let target = document.getElementById(data);
	// 			let headerHeight = document.querySelector('header').offsetHeight + 55;

	// 			window.scrollTo({
	// 				top: target.offsetTop - headerHeight,
	// 				behavior: 'smooth'
	// 			});
	// 		});
	// 	});
	// }

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}
	
	if(document.getElementById('menu-container')){
		let linksMenu = document.querySelectorAll('.privary-navigation__item a');
		let imgsMenu = document.querySelectorAll('.menu__images img');

		const openBtn = document.querySelector('.js-open-menu');
		const closeBtn = document.querySelector('.js-close-menu');
		const menu = document.getElementById('menu-container');

		linksMenu.forEach((link)=>{
			link.addEventListener('mouseenter',() => syncMenuImage(link,imgsMenu));
			link.addEventListener('focus',() => syncMenuImage(link,imgsMenu));
		})

		function syncMenuImage(link, images) {
			const match = link.className.match(/img-([^\s]+)/);			
			if (!match) return;
			const targetName = match[1].replace('active', '').trim();
			images.forEach((img) => {
				img.classList.toggle('active', img.dataset.image === targetName);
			});
		}		

		function toggleMenu(isOpen) {
			if (isOpen) {
				menu.classList.add('show');
				openBtn.setAttribute('aria-expanded', 'true');
				
				const firstLink = menu.querySelector('a, button');
				// Solo ejecuta el focus si firstLink existe Y shouldFocus es true
				if (firstLink ) {
					setTimeout(() => firstLink.focus(), 100);
				}
			} else {
				menu.classList.remove('show');
				openBtn.setAttribute('aria-expanded', 'false');
				openBtn.focus();
			}
		}

		if (window.innerWidth <= 900) {
			const menu_Items = document.querySelectorAll('#privary-navigation li:has(.submenu)')
		let prevMenuItem
		menu_Items.forEach((element) => {
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
				<li class="privary-navigation__item primary-nav-js">
					<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
				</li>`

			Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}
			
			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}

		if (openBtn && closeBtn && menu) {
			openBtn.addEventListener('click', (e) => {
				const isKeyboard = e.pointerType === ''; 
				toggleMenu(true, isKeyboard);
			});
			closeBtn.addEventListener('click', () => toggleMenu(false));

			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape' && menu.classList.contains('show')) {
					toggleMenu(false);
				}
			});

			menu.addEventListener('keydown', (e) => {
				if (e.key !== 'Tab') return;

				const focusables = menu.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])');
				const firstElement = focusables[0];
				const lastElement = focusables[focusables.length - 1];

				if (e.shiftKey) {
					if (document.activeElement === firstElement) {
						e.preventDefault();
						lastElement.focus();
					}
				} else {
					if (document.activeElement === lastElement) {
						e.preventDefault();
						firstElement.focus();
					}
				}
			});
		}
	}

	if(document.querySelector('.group-start.with-intro-content')){
		let introContent = document.querySelector('.intro-content');
		document.querySelector('.group-start.with-intro-content').insertAdjacentElement('afterbegin',introContent);
	}

	if(document.querySelector('.js-open-box')){
		let allButtons = document.querySelectorAll('.js-open-box');
		allButtons.forEach((button)=>{
			button.addEventListener('click',(e)=>{
				let dataId = button.getAttribute('href').split('#')[1];
				e.preventDefault();
				button.classList.toggle('active');
				document.getElementById(dataId).classList.toggle('active');
			})
		})
	}

	if(document.querySelector('.menus-quad')){
		let allTabsMenu = document.querySelectorAll('.menus-quad__filter button');
        let allMenus = document.querySelectorAll('.menus-quad__menu');
        let lastClickMenu = null;

        allTabsMenu.forEach((tabMenu)=>{
            tabMenu.addEventListener('click',()=>{
                let dataMenu = tabMenu.dataset.menu;
                tabMenu.classList.add('active');
                if(lastClickMenu){
                    lastClickMenu.classList.remove('active');
                }
                lastClickMenu = tabMenu;
                allMenus.forEach((menu)=>{
                    menu.classList.toggle('hidden', menu.dataset.menu != dataMenu);
                })
            })
        });
	
        allTabsMenu[0].click();
	}

	if(document.querySelector('.accordion')){
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    }

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}